@for (crumb of breadcrumbs(); track crumb.path; let crumbIndex = $index) {
  <div class="breadcrumb" [attr.data-qa]="`breadcrumb-item-${crumb.path}`">
    @if (crumb.dynamic && crumb.label() === undefined) {
      <p-progress-spinner />
    } @else if (breadcrumbs().length - 1 === crumbIndex) {
      {{ crumb.label() | translate }}
    } @else {
      <a [routerLink]="crumb.path">
        {{ crumb.label() | translate }}
      </a>
    }
    @if (breadcrumbs().length - 1 > crumbIndex) {
      <span class="spacer"> / </span>
    }
  </div>
}
